import { useSearchParams } from '@/shared/hooks/useSearchParams';
import { QueryParameter } from '@/shared/constants/queryParams';

import { ALL_CHANNELS_ID } from '../constants';

export function useChannelCategoryTabQueryParam() {
    const searchParams = useSearchParams();
    return searchParams.get(QueryParameter.CHANNEL_CATEGORY_TAB) ?? ALL_CHANNELS_ID;
}
